import React from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { NavMenu } from "./index";
import MapIcon from "@mui/icons-material/Map";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const Header = () => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#3B3838",
          display: { lg: "block", md: "block", xs: "block" },
        }}
      >
        <Box sx={{ paddingY: "1%" }}>
          <Grid container lg={12} md={12} xs={12}>
            <Grid item lg={3} md={3} xs={12}>
              <Box sx={{ paddingTop: { lg: "0", md: "2%", xs: "3%" } }}>
                <Typography
                  variant="h4"
                  sx={{ color: "#fff", fontWeight: "800" }}
                >
                  Heard Group
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              lg={3}
              md={2}
              xs={12}
              sx={{
                display: { lg: "block", md: "block", xs: "none" },
              }}
            ></Grid>
            <Grid item lg={3} md={3} xs={12}>
              <Box
                sx={{
                  display: { xl: "flex", lg: "flex", md: "flex", xs: "none" },
                }}
              >
                <Box
                  sx={{
                    color: "#ED7D31",
                    marginRight: { md: "2%", xs: "0", lg: "0", xl: "0" },
                  }}
                >
                  <MapIcon fontSize="large" />
                </Box>
                <Box
                  sx={{
                    textAlign: { lg: "left", md: "left", xs: "center" },
                    paddingLeft: { lg: "5%", md: "2%", xs: "0%" },
                    display: { lg: "block", md: "block", xs: "none" },
                  }}
                >
                  <Box>
                    <Typography
                      variant="p"
                      sx={{ fontSize: { lg: "20px", color: "#fff" } }}
                    >
                      Egypt
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      variant="p"
                      sx={{ fontSize: { lg: "12px" }, color: "#fff" }}
                    >
                      06 Mohandesen St, Agouza,Gizza
                    </Typography>{" "}
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              lg={3}
              md={3}
              xs={12}
              sx={{
                display: { lg: "block", md: "block", xs: "none" },
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Box sx={{ color: "#ED7D31" }}>
                  <MailOutlineIcon fontSize="large" />
                </Box>
                <Box
                  sx={{
                    textAlign: "left",
                    paddingLeft: { lg: "5%", md: "2%" },
                  }}
                >
                  <Box>
                    <Typography
                      variant="p"
                      sx={{ fontSize: { lg: "20px" }, color: "#fff" }}
                    >
                      info@heardgroup.com
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      variant="p"
                      sx={{ fontSize: { lg: "12px" }, color: "#fff" }}
                    >
                      Office Hour 09:00 am - 05:00 pm
                    </Typography>{" "}
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Divider
          sx={{
            backgroundColor: "#fff",
            marginTop: { lg: "0", md: "0", xs: "0px" },
          }}
        />
        <Box>
          <Box sx={{ paddingY: "1%" }}>
            <Grid container lg={12} md={12} xs={12}>
              <Grid item lg={12} md={8} xs={12}>
                <Box sx={{ zIndex: "10", position: "relative" }}>
                  <NavMenu />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Header;
